<template>
  <div>Logging in...</div>
</template>

<script>
export default {
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const userId = urlParams.get("user_id");

    if (token && userId) {
      localStorage.setItem("token", token);

      try {
        const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/users/${userId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Ошибка получения данных пользователя");
        }

        const userInfo = await response.json();
        localStorage.setItem("name", userInfo.data.name);
        localStorage.setItem("user_lastname", userInfo.data.user_lastname);
        localStorage.setItem("position", userInfo.data.position);
        localStorage.setItem("company", userInfo.data.company);
        localStorage.setItem("profile_picture", userInfo.data.profile_picture);

        this.$store.commit("main/setUserInfo", userInfo.data);

        this.$router.push("/chat");
      } catch (error) {
        console.error("Ошибка при получении данных пользователя", error);
        this.$router.push("/login");
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
